<script setup>
import { inject } from 'vue'
import Sprite from '@/__core__/components/sprite/Sprite.vue'
import SzwImage from '@/__v1.5__/components/image/Image.vue'

const props = defineProps({
  event: Object
})

const status = inject('status')

const emit = defineEmits(['card-clicked'])

function emitCardClick() {
  emit('card-clicked', props.event)
}
</script>

<template>
  <div
    v-if="status === 'loading'"
    class="szw-w-full szw-h-[108px] szw-flex szw-flex-col szw-bg-background szw-rounded-2 szw-px-1 szw-py-2 szw-gap-2 szw-cursor-pointer"
    style="border: 1px solid var(--szw-border)"
  >
    <div class="szw-flex szw-w-full szw-h-5 szw-px-1 szw-items-center szw-gap-1 szw-animate-pulse">
      <span class="szw-w-[42px] szw-h-[12px] szw-bg-background-color-secondary szw-rounded" />
      <span class="szw-text-background-color-secondary szw-rounded szw-text-font-size-xs szw-leading-font-line-height-xs szw-font-medium szw-uppercase">•</span>

      <span class="szw-flex szw-items-center szw-h-5 szw-w-10 szw-bg-background-color-secondary szw-rounded" />
    </div>

    <div class="szw-h-[64px] szw-w-full szw-flex szw-flex-col szw-animate-pulse">
      <div class="szw-w-full szw-flex szw-items-center" v-for="team of 2" :key="team">
        <span class="szw-h-4 szw-w-4 szw-m-2 szw-bg-background-color-secondary szw-rounded-full" />
        <span class="szw-w-[120px] szw-h-[12px] szw-bg-background-color-secondary szw-rounded" />

        <div class="szw-flex szw-items-center szw-justify-center szw-ml-auto szw-bg-background-color-secondary szw-h-6 szw-w-8 szw-rounded">
          <span class="szw-w-3 szw-h-3 szw-bg-color-disable szw-rounded" />
        </div>
      </div>
    </div>
  </div>

  <div
    v-else
    class="szw-w-full szw-h-[108px] szw-flex szw-flex-col szw-bg-background szw-rounded-2 szw-px-1 szw-py-2 szw-gap-2 szw-cursor-pointer"
    style="border: 1px solid var(--szw-border)"
    @click="emitCardClick"
  >
    <div class="szw-flex szw-w-full szw-h-5 szw-px-1 szw-items-center szw-gap-1 szw-text-font-size-xs szw-leading-font-line-height-xs szw-font-medium szw-uppercase">
      <span>{{ event.startDate }}</span>
      <span>•</span>

      <div
        :class="[
          'szw-flex szw-items-center szw-gap-1 szw-h-5',
          event.live ? 'szw-bg-label-color-live szw-px-2 szw-py-0.5 szw-rounded szw-text-text-icon-secondary' : 'szw-bg-transparent'
        ]"
      >
        <sprite v-if="event.live" sprite-id="live-indicator" />
        <span>{{ event.timeStatus }}</span>
      </div>

      <div class="szw-flex szw-items-center szw-justify-center szw-ml-auto szw-h-6 szw-w-7">
        <span>{{ event.outcome }}</span>
      </div>
    </div>

    <div class="szw-h-[64px] szw-w-full szw-flex szw-flex-col szw-text-font-size-md szw-leading-font-line-height-md">
      <div class="szw-w-full szw-flex szw-items-center" v-for="team of event.teams" :key="team.id">
        <div class="szw-h-4 szw-w-4 szw-m-2 szw-col__center szw-justify-center szw-text-xxs">
          <szw-image :src="team.logoUrl" :fallback-content="team.shortName" :alt="team.shortName" />
        </div>

        <span>{{ team.name }}</span>

        <div class="szw-flex szw-items-center szw-justify-center szw-ml-auto szw-h-6 szw-w-fit szw-font-medium">
          <div v-if="event.hasPenalties" class="szw-flex szw-items-center szw-justify-center szw-h-6 szw-w-8">
            <span>({{ team.penaltyScore }})</span>
          </div>

          <div :class="['szw-flex szw-items-center szw-justify-center szw-h-6 szw-w-8', { 'szw-bg-background-color-secondary szw-rounded': !event.hasPenalties }]">
            <span>{{ team.score }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
